// BrainForge API Configuration
const API_BASE = process.env.REACT_APP_API_URL || '';

export const apiUrl = (path) => {
  if (API_BASE) {
    return `${API_BASE}${path}`;
  }
  return path;
};

const apiConfig = { apiUrl };
export default apiConfig;
